/* eslint-disable react/no-array-index-key */
import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  useDisclosure,
  ModalBody,
  Icon,
  Box,
  Flex,
  Text,
  UnorderedList,
  ListItem,
  ModalCloseButton,
  Collapse,
  Tag,
  ListIcon,
  List,
  Tooltip,
} from '@chakra-ui/react';
import { FiClock, FiChevronsDown, FiCircle, FiFilm } from 'react-icons/fi';
import { FaCheckCircle, FaUserFriends } from 'react-icons/fa';
import BlgBadge from '../Badge';
import { Episode } from '../../@types';
import { WaveBackground } from '../waveBackground/WaveBackground';

export interface iModalEpisode {
  episode: Episode;
  isOpen: boolean;
  onClose: () => void;
}

interface iAccordionInfo {
  title: string;
  standards: {
    title: string;
    description: string;
  }[];
  list?: { title: string; description: string }[];
}

const AccordionInfo = ({ title, standards, list }: iAccordionInfo) => {
  const { isOpen, onToggle } = useDisclosure();
  return (
    <Box>
      <Flex
        onClick={onToggle}
        alignItems="center"
        justifyContent="space-between"
        cursor="pointer"
        borderColor="gray.200"
        gap={2}
      >
        <Flex alignItems="center" gap={2}>
          <Icon
            as={FiChevronsDown}
            transform={isOpen ? 'rotate(-180deg)' : ''}
          />
          <Text fontSize={18} fontWeight={700}>
            {title}
          </Text>
        </Flex>
      </Flex>
      <Collapse in={isOpen} animateOpacity>
        <Flex flexDir="column" p={4} mt={2} borderRadius={8} gap={2}>
          {/* <Text fontSize={18} fontWeight={500} color="newGreen.500">
            Grades 9 & 1- Availability of Food D1.3
          </Text>
          <Text fontSize={14} fontWeight={600} color="gray.700">
            {description}
          </Text> */}

          <List flexDir="column" gap={1}>
            {standards?.map((item, key) => (
              <Flex key={key} flexDir="column" gap={2} pl={4} mb={4}>
                <ListItem
                  fontWeight="bold"
                  color="gray.800"
                  display="flex"
                  alignItems="center"
                >
                  <ListIcon as={FiCircle} fontSize={10} />
                  {item.title}
                </ListItem>
                <Text fontSize={16} fontWeight={400} color="gray.800">
                  {item.description}
                </Text>
              </Flex>
            ))}
          </List>
        </Flex>
      </Collapse>
    </Box>
  );
};

export const BlgModalEpisode = ({
  episode,
  isOpen,
  onClose,
}: iModalEpisode) => {
  const age_range = JSON.parse(episode.age_restrictions)[0] || 'All Ages';
  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} size="4xl">
        <ModalOverlay />
        <ModalContent borderRadius={12} bg="darkBlue.500" color="white">
          <ModalHeader
            pb={8}
            pt={8}
            px={8}
            display="flex"
            flexDir="column"
            gap={4}
          >
            <Flex alignItems="center" gap={2}>
              <Box
                bg="red.500"
                p="3px"
                px={1.5}
                borderRadius="full"
                h={10}
                w={10}
              >
                <Icon color="white" as={FiFilm} fontSize={28} />
              </Box>
              <Text fontSize={22} fontWeight={800} color="white">
                {episode.title}
              </Text>
              <Icon as={FiClock} ml={2} color="newGreen.500" />
              <Text
                fontSize={16}
                fontWeight={400}
                color="newGreen.500"
                textTransform="uppercase"
              >
                {episode.time} minutes
              </Text>
              <Icon as={FaUserFriends} ml={2} color="yellow.500" />
              <Text
                fontSize={16}
                fontWeight={400}
                color="yellow.500"
                textTransform="uppercase"
              >
                Ages {age_range}
              </Text>
            </Flex>
            <Flex pl={12} gap={1} flexWrap="wrap">
              {episode.tags.map((tag, key) => (
                <BlgBadge colorScheme="ligthBlue" key={tag}>
                  {tag}
                </BlgBadge>
              ))}
            </Flex>
            <Flex pl={12} gap={2}>
              {episode.goals?.map((goal) => (
                <Tooltip
                  key={goal.id}
                  fontSize="0.8rem"
                  label={goal.title}
                  shouldWrapChildren
                >
                  <Box h={3} w={3} bg={goal.color} borderRadius="full" />
                </Tooltip>
              ))}
            </Flex>
          </ModalHeader>
          <ModalCloseButton colorScheme="whiteAlpha" bgColor="darkBlue.500" />
          <ModalBody color="darkBlue.500" p={0}>
            <WaveBackground
              bg="white"
              p={8}
              py={12}
              flexDir="column"
              gap={5}
              borderRadius={12}
            >
              <Flex gap={2}>
                <Icon color="newGreen.500" as={FaCheckCircle} fontSize={32} />
                <Text fontSize={22} fontWeight={800}>
                  Key Learning Outcomes/Assignments
                </Text>
              </Flex>
              <Flex flexDir="column" gap={1} whiteSpace="pre-line">
                {episode.learning_outcomes}
              </Flex>
              {episode.keyLearning
                ? episode.keyLearning.map((item, key) => (
                    <AccordionInfo
                      key={key}
                      title={item.category}
                      standards={item.standards}
                    />
                  ))
                : ''}
            </WaveBackground>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
